import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMappingConfiguration,
    withDefaultSearchParamsMetadata,
    withFragmentSearchFilter,
    withMetadata,
    withSearchFilter,
} from '@pf/shared-utility';
import {
    RequisitionCreate,
    RequisitionDto,
    RequisitionRead,
    RequisitionSearchParams,
} from '../../entities/requisition.dto';
import {
    CustomFieldMetadataMap,
    ResourceAuthSymbol,
} from '@pf/shared/util-platform';
import { withWarehouseSearchFilter } from '../wms-mapping.util';

const symbols = entitySymbols(PFWmsEntities.Requisition);

withDefaultEntityMetadata<RequisitionDto>(symbols.dto, {
    expectedBy: String,
    externalReferenceId: String,
    notes: String,
    priority: String,
    purchaseOrder: Object,
    requestingContact: Object,
    requisitionLines: [Object],
    resourceAuth: ResourceAuthSymbol,
    status: String,
    warehouse: Object,
    customFields: [CustomFieldMetadataMap.symbols.dto],
});

withDefaultEntityMetadata<RequisitionRead>(symbols.entity, {
    expectedBy: String,
    externalReferenceId: String,
    notes: String,
    priority: String,
    purchaseOrder: Object,
    requestingContact: Object,
    requisitionLines: [Object],
    resourceAuth: ResourceAuthSymbol,
    status: String,
    warehouse: Object,
    customFields: [CustomFieldMetadataMap.symbols.entity],
});

withMetadata<RequisitionCreate>(symbols.createBody, {
    expectedBy: String,
    externalReferenceId: String,
    notes: String,
    priority: String,
    purchaseOrderId: String,
    requestingContactId: String,
    resourceAuth: ResourceAuthSymbol,
    status: String,
    warehouseId: String,
});

withDefaultSearchParamsMetadata<RequisitionSearchParams>(symbols.searchParams, {
    warehouseId: String,
    requestingContactId: String,
    purchaseOrderId: String,
    expectedByRangeStart: String,
    expectedByRangeEnd: String,
    status: String,
    priority: String,
    externalReferenceId: String,
    ids: [String],
});

export const RequisitionMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<RequisitionRead, RequisitionDto>(
            mapper,
            symbols.entity,
            symbols.dto
        );
        createMap<RequisitionDto, RequisitionRead>(
            mapper,
            symbols.dto,
            symbols.entity
        );
        createMap<RequisitionDto, RequisitionCreate>(
            mapper,
            symbols.dto,
            symbols.createBody
        );
        createMap<IQueryParams<RequisitionDto>, RequisitionSearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            withSearchFilter('status'),
            withSearchFilter('priority'),
            withSearchFilter('externalReferenceId'),
            withWarehouseSearchFilter(),
            withFragmentSearchFilter('purchaseOrder'),
            withFragmentSearchFilter('requestingContact'),
            ...withDefaultSearchParamsMappingConfiguration()
        );
    },
};
